<template>
  <el-dialog
    :title="title"
    :visible="visible"
    :close-on-click-modal="false"
    width="800px"
    @close="handleClose"
  >
    <div>
      <el-row>
        <el-col :span="6">选择照片</el-col>
        <el-col :span="18">
          <el-form>
            <el-upload
              ref="upload"
              :class="['avatar-uploader',showAdd?'':'hide-upload']"
              :action="`${action}?warehouseInUuid=${warehouseInUuid}`"
              :on-success="handleSuccess"
              :on-error="handleError"
              :on-change="handleChange"
              :on-remove="handleRemove"
              :before-upload="handleBeforeUpload"
              :on-exceed="handleExceed"
              :file-list="fileList"
              :auto-upload="false"
              :headers="headers"
              list-type="picture-card"
              :multiple="true"
              :on-preview="handlePictureCardPreview"
              :limit="6"
              accept=".jpeg,.gif,.png,.bmp,.tiff"
              name="file"
            >
              <i class="el-icon-plus avatar-uploader-icon" />
              <div
                slot="tip"
                class="el-upload__tip"
              >文件大小不可超过20M，支持JPG,GIF,BMP,PNG,TIFF格式</div>
            </el-upload>
          </el-form>
        </el-col>
      </el-row>
      <el-row
        slot="footer"
        style="margin-top:15px;"
      >
        <el-col
          :span="18"
          :offset="6"
        >
          <el-form>
            <span>
              <el-button
                type="primary"
                @click="submitUpload"
              >开始上传</el-button>
              <el-button @click="handleClose">取 消</el-button>
            </span>
          </el-form>
        </el-col>
      </el-row>
    </div>
    <el-dialog
      class="pic-preview"
      :visible.sync="dialogVisible"
      append-to-body
    >
      <img
        width="100%"
        :src="dialogImageUrl"
        alt=""
      >
    </el-dialog>
  </el-dialog>
</template>
<script>
import { getToken } from '@/utils/auth'
export default {
  name: 'UploadPicDialog',
  props: {
    title: { type: String, default: () => '' },
    visible: { type: Boolean, default: () => false },
    action: { type: String, default: () => '' },
    warehouseInUuid: { type: String, default: () => '' }
  },
  data() {
    return {
      dialogVisible: false,
      fileList: [],
      uploadSuccess: false,
      headers: {
        sessionId: getToken(),
        ContentType: 'multipart/form-data'
      },
      dialogImageUrl: ''
    }
  },
  computed: {
    showAdd() {
      return this.fileList.length < 6
    }
  },
  methods: {
    submitUpload() {
      this.$refs.upload.submit()
    },
    handleChange(file, fileList) {
      console.log('change', file.status)
      this.fileList = fileList
    },
    handleRemove(file, fileList) {
      console.log('remove')
      this.fileList = fileList
    },
    handleBeforeUpload(file) {
      const isLt20M = file.size / 1024 / 1024 < 20
      if (!isLt20M) {
        this.$message.error('文件大小不能超过20MB!')
      }
      return isLt20M
    },
    handleSuccess(res, file) {
      this.$message.success(`${file.name}上传成功`)
    },
    handleError(err, file, fileList) {
      console.log('err', err)
      this.fileList = fileList.push(file)
      this.$message.error(`${file.name}上传失败`)
    },
    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url
      this.dialogVisible = true
    },
    handleExceed(files, fileList) {
      this.$message.error('一次最多选择6张图片')
    },
    handleClose() {
      this.fileList = []
      this.$emit('onClose')
    }
  }
}
</script>
<style lang="scss">
.avatar-uploader {
  .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    width: 146px;
    height: 146px;
    position: relative;
    overflow: hidden;
    &:hover {
      border-color: #409eff;
    }
    &-icon {
      font-size: 28px;
      color: #8c939d;
      width: 146px;
      height: 146px;
      line-height: 146px;
      text-align: center;
    }
    &-list__item.is-fail {
      border-color: red;
      overflow: hidden;
    }
  }
  &.hide-upload .el-upload {
    display: none;
  }
  .avatar {
    width: 146px;
    height: 146px;
    display: block;
  }
}
.pic-preview {
  .el-dialog__header {
    border: none;
  }
}
</style>
